class HighlitedVideo {
  constructor(elParent){
    this.elParent = elParent
    this.elMask = this.elParent.find('.mhg_block_highlightvideo_mask')

    this.initYoutubeIframeApi()

    this.runEvents()
  }

  runEvents(){
    this.elMask.click(() => {
      this.runAutoPlay()
    })
  }

  runAutoPlay(){
    this.player.playVideo()
    this.elMask.fadeOut('slow')
    this.elParent.find('.mhg_field_video_player').fadeIn('slow')

    // const videoUrl = new URL( this.videoIframe.attr('src') )
    // videoUrl.searchParams.append('autoplay', 1)
    // this.videoIframe.attr('src', videoUrl)
  }

  initYoutubeIframeApi(){
    if (jQuery('#mhg_video_player').length > 0){

      const tag = document.createElement('script');
      tag.src = "//www.youtube.com/iframe_api";
      const firstScriptTag = document.getElementsByTagName('script')[0];
      firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

      window.onYouTubeIframeAPIReady = () => {
          this.player = new YT.Player('mhg_video_player', {
              // height: '100%',
              // width: '100%',
              videoId: this.elParent.find('#mhg_video_player').data('videoid'),  // youtube video id
              host: 'https://www.youtube.com',
              playerVars: {
                  //'autoplay': 0,
                  'rel': 0,
                  'showinfo': 0
              }
          });
      }
    }
  }
}

export default HighlitedVideo



// WEBPACK FOOTER //
// ./src/hightlited_video.js